import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: "100%",
        marginTop: "15px",
        textOverflow: "true",
    },
    tableContainer: {
        maxWidth: "100%",
    },
    typography: {
        "&.MuiTypography-root": {
            fontFamily: theme.typography.subtitle2.fontFamily,
            fontSize: theme.typography.subtitle2.fontSize,
            color: theme.palette.text.primary,
        },
    },
    textCenter: {
        textAlign: "center",
    },
    arrowIcon: {
        transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    },
    tableExpandedRow: {
        " & td": {
            borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
    },
    lastExpandedRow: {
        " & td": {
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
        },
    },
    tableCellWrapper: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    contentTableCellExpanded: {
        padding: `0px 0px 0px 8px !important`,
    },
    tableCellWrapperExpanded: {
        display: "flex",
        alignItems: "center",
    },
}));
